module.exports = __webpack_public_path__ + "./fonts/pt-root-ui_bold.ttf";